
/* Kit scent picker (Oct 6, client request): the refresh kit page now leads with the full scent list as colored chips,
   like the ring page, instead of the named mood kits + a tiny native select. Choosing a scent drives the title, image,
   "what's inside" and the variant added. The named kits stay as a secondary "ready-made kits" shelf that preselects
   their scent. Also fixes the old select never being set to the kit's scent: it always sat on "allergy relief", so
   "the fresh start kit" (orange) added an allergy relief kit unless the shopper changed it. Pod is chips too. */
(function(){
  function boot(){
    var view=document.getElementById('view-kitpdp');
    var ss=document.getElementById('kpScentSel'),ps=document.getElementById('kpPodSel');
    if(!view||!ss||!ps||!window.__VMAP||!__VMAP.kit||typeof window.renderKitPdp!=='function')return;
    var keys=Object.keys(__VMAP.kit);
    function scentOf(k){for(var i=0;i<SCENTS.length;i++){if(esScent(SCENTS[i].n)===esScent(k))return SCENTS[i]}return null}
    var order=[];
    SCENTS.forEach(function(s){keys.forEach(function(k){if(esScent(k)===esScent(s.n)&&order.indexOf(k)<0)order.push(k)})});
    keys.forEach(function(k){if(order.indexOf(k)<0)order.push(k)});
    function cap(t){return t.replace(/(^|[\s-])([a-z])/g,function(m,a,b){return a+b.toUpperCase()})}

    /* scent group, right under the kit's one-line summary */
    var label=view.querySelector('.pdp-info > .opt-label');
    var g=document.createElement('div');g.className='opt-group';g.id='kpScentGroup';
    g.innerHTML='<div class="opt-label">scent &middot; <span id="kpScentName" style="color:var(--ink);letter-spacing:0"></span></div><div id="kpScentShelf" class="shelf"></div>';
    label.parentNode.insertBefore(g,label.nextSibling);
    var shelf=g.querySelector('#kpScentShelf');
    order.forEach(function(k){
      var s=scentOf(k);
      var b=document.createElement('button');b.className='chip2';b.setAttribute('data-kit-scent',k);
      b.innerHTML='<span class="d" style="background:'+((s&&SCOL[s.n])||'#999999')+'"></span>'+k;
      b.onclick=function(){kitPdp.kit=kitPdp.i;kitPdp.scent=k;window.renderKitPdp()};
      shelf.appendChild(b);
    });

    /* named kits become secondary */
    var kitName=document.getElementById('kpKitName'),kitGroup=kitName&&kitName.closest('.opt-group');
    if(kitGroup){
      /* keep #kpKitName: renderKitPdp writes to it */
      var kl=kitGroup.querySelector('.opt-label');
      if(kl&&kl.firstChild&&kl.firstChild.nodeType===3)kl.firstChild.nodeValue='ready-made kits ';
      var db=document.getElementById('kpDiscoverBtn');if(db)db.innerHTML='browse kits by mood &#9662;';
      /* picking a ready-made kit (even the current one) re-selects that kit's scent */
      var ks=document.getElementById('kpShelf');if(ks)ks.addEventListener('click',function(){kitPdp.kit=null},true);
    }

    /* pod as chips; the select stays (hidden) as the value the add button reads */
    var podSel=ps.closest('.opt-group');ps.style.display='none';
    var pods=[['black','black pod','#17121F'],['white','white pod','#fff'],['glass','bamboo & glass','#C9A87C']];
    var podShelf=document.createElement('div');podShelf.className='shelf';podShelf.id='kpPodShelf';podShelf.style.marginTop='6px';
    pods.forEach(function(p){
      var b=document.createElement('button');b.className='chip2';b.setAttribute('data-pod',p[0]);
      b.innerHTML='<span class="d" style="background:'+p[2]+';border:1px solid var(--line)"></span>'+p[1]+(p[0]==='glass'?' &middot; +$6':'');
      b.onclick=function(){ps.value=p[0];ps.dispatchEvent(new Event('change'));mark()};
      podShelf.appendChild(b);
    });
    podSel.appendChild(podShelf);
    ss.closest('.opt-group').style.display='none';

    /* same selected look as the ring page's scent chips (updateSel) */
    function paint(b,sel){
      b.setAttribute('aria-current',sel?'true':'false');
      b.style.background=sel?'var(--ink)':'var(--white)';
      b.style.color=sel?'var(--cream)':'var(--ink)';
      b.style.borderColor=sel?'var(--ink)':'var(--line)';
    }
    function mark(){
      shelf.querySelectorAll('button').forEach(function(b){paint(b,b.getAttribute('data-kit-scent')===kitPdp.scent)});
      podShelf.querySelectorAll('button').forEach(function(b){paint(b,b.getAttribute('data-pod')===ps.value)});
    }

    /* opening a kit from anywhere else (bundles page, search, nav) also starts from that kit's scent */
    var origOpen=window.openKitPdp;
    if(typeof origOpen==='function')window.openKitPdp=function(){kitPdp.kit=null;return origOpen.apply(this,arguments)};
    var orig=window.renderKitPdp;
    window.renderKitPdp=function(){
      orig.apply(this,arguments);
      var k=KITSP[kitPdp.i];if(!k)return;
      var anchor=(window.__KITANCHOR||{})[k.n];
      /* opening a named kit (or first render) preselects its scent; a scent chip keeps kitPdp.kit so its choice sticks */
      if(kitPdp.kit!==kitPdp.i){kitPdp.kit=kitPdp.i;kitPdp.scent=anchor||kitPdp.scent||order[0]}
      var sc=kitPdp.scent,s=scentOf(sc),named=(sc===anchor);
      ss.value=sc;ss.dispatchEvent(new Event('change'));
      document.getElementById('kpScentName').textContent=sc;
      if(!named&&s){
        var t='refresh kit · '+sc;
        document.getElementById('kpTitle').textContent=t;
        document.getElementById('kpCrumb').textContent=t;
        var chip=document.getElementById('kpMood');chip.textContent=s.mood;chip.style.background='var('+s.c+')';
        chip.style.color=(typeof INK_MOODS!=='undefined'&&INK_MOODS[s.c])?'var(--ink)':'var(--cream)';
        document.getElementById('kpAbout').innerHTML='<span class="serif">two '+sc+' rings, one to wear and one riding inside the bay, plus the '+sc+' oil that refills them.</span>';
        var slug=s.img.slice(3);
        var img=document.getElementById('kpImg');img.src=imSrc('ob-'+slug)||imSrc(s.img)||img.src;img.alt=t;
      }
      if(s){
        var slug2=s.img.slice(3);
        document.getElementById('kpRingName').textContent='2 '+sc+' rings';
        var rt=document.getElementById('kpRingThumb');rt.src=imSrc(s.img)||rt.src;
        document.getElementById('kpOilName').textContent=cap(sc)+' oil';
        var ot=document.getElementById('kpOilThumb');ot.src=imSrc('ob-'+slug2)||ot.src;
        var bt=document.getElementById('kpBayThumb');if(bt)bt.src=imSrc('ib-'+slug2)||imSrc('im-bay')||bt.src;
      }
      var kn=document.getElementById('kpKitName');if(kn)kn.textContent=named?'· '+k.n:'';
      mark();
    };
    /* a cold landing may have rendered the kit before this ran: re-render with the scent picker */
    try{window.renderKitPdp()}catch(e){}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
